import { interfaceIds } from '@soundxyz/sound-protocol';
import { rangeEditionMinterV1Abi } from '../abi/range-edition-minter-v1.mjs';
import { rangeEditionMinterV2Abi } from '../abi/range-edition-minter-v2.mjs';
import { rangeEditionMinterV2_1Abi } from '../abi/range-edition-minter-v2_1.mjs';
import { merkleDropMinterV1Abi } from '../abi/merkle-drop-minter-v1.mjs';
import { merkleDropMinterV2Abi } from '../abi/merkle-drop-minter-v2.mjs';
import { merkleDropMinterV2_1Abi } from '../abi/merkle-drop-minter-v2_1.mjs';

const minterAbiMap = {
  [interfaceIds.IRangeEditionMinter]: rangeEditionMinterV1Abi,
  [interfaceIds.IRangeEditionMinterV2]: rangeEditionMinterV2Abi,
  [interfaceIds.IRangeEditionMinterV2_1]: rangeEditionMinterV2_1Abi,
  [interfaceIds.IMerkleDropMinter]: merkleDropMinterV1Abi,
  [interfaceIds.IMerkleDropMinterV2]: merkleDropMinterV2Abi,
  [interfaceIds.IMerkleDropMinterV2_1]: merkleDropMinterV2_1Abi
};
const MINTER_ROLE = 2n;
const editionInitFlags = {
  METADATA_IS_FROZEN: 1,
  // 1 << 0
  MINT_RANDOMNESS_ENABLED: 2,
  // 1 << 1
  OPERATOR_FILTERING_ENABLED: 4
  // 1 << 2
};
const UINT32_MAX = 4294967295;
const NULL_ADDRESS = "0x0000000000000000000000000000000000000000";
const NON_NULL_ADDRESS = "0x0000000000000000000000000000000000000001";
const NULL_BYTES32 = "0x0000000000000000000000000000000000000000000000000000000000000000";
const MINT_GAS_LIMIT_MULTIPLIER = 1.2;
const MINT_FALLBACK_GAS_LIMIT = 200000n;
const ContractErrorName = {
  // SoundEdition
  MetadataIsFrozen: "MetadataIsFrozen",
  InvalidRoyaltyBPS: "InvalidRoyaltyBPS",
  InvalidRandomnessLock: "InvalidRandomnessLock",
  ExceedsEditionAvailableSupply: "ExceedsEditionAvailableSupply",
  InvalidAmount: "InvalidAmount",
  InvalidFundingRecipient: "InvalidFundingRecipient",
  InvalidEditionMaxMintableRange: "InvalidEditionMaxMintableRange",
  MaximumHasAlreadyBeenReached: "MaximumHasAlreadyBeenReached",
  ExceedsAddressBatchMintLimit: "ExceedsAddressBatchMintLimit",
  MintRandomnessAlreadyRevealed: "MintRandomnessAlreadyRevealed",
  NoAddressesToAirdrop: "NoAddressesToAirdrop",
  MintHasConcluded: "MintHasConcluded",
  MintsAlreadyExist: "MintsAlreadyExist",
  // IMinterModule
  Underpaid: "Underpaid",
  ExceedsAvailableSupply: "ExceedsAvailableSupply",
  MintNotOpen: "MintNotOpen",
  MintPaused: "MintPaused",
  InvalidTimeRange: "InvalidTimeRange",
  Unauthorized: "Unauthorized",
  InvalidAffiliateFeeBPS: "InvalidAffiliateFeeBPS",
  FeeRegistryIsZeroAddress: "FeeRegistryIsZeroAddress",
  // Child minters
  InvalidMaxMintableRange: "InvalidMaxMintableRange",
  ExceedsMaxPerAccount: "ExceedsMaxPerAccount",
  MaxMintablePerAccountIsZero: "MaxMintablePerAccountIsZero",
  InvalidMerkleProof: "InvalidMerkleProof",
  MerkleRootHashIsEmpty: "MerkleRootHashIsEmpty"
};

export { ContractErrorName, MINTER_ROLE, MINT_FALLBACK_GAS_LIMIT, MINT_GAS_LIMIT_MULTIPLIER, NON_NULL_ADDRESS, NULL_ADDRESS, NULL_BYTES32, UINT32_MAX, editionInitFlags, minterAbiMap };
